import { ApiEndPoint } from './apiEndPoint'

export const getInstallments = new ApiEndPoint('startup/installments')